module.exports = __webpack_public_path__ + "logo.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 248
 ** module chunks = 0
 **/